import { SelectionModel } from '@angular/cdk/collections';
import {
	AfterContentChecked,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import { AlertService } from 'src/app/shared/ims-alerts/ims-alerts.service';
import { Utils } from 'src/app/shared/utility/utils';

@Component({
	selector: 'app-shared-allegation-selection',
	templateUrl: './shared-allegation-selection.component.html',
	styleUrls: ['./shared-allegation-selection.component.scss'],
})
export class SharedAllegationSelectionComponent implements OnInit, OnDestroy, AfterContentChecked {
	@ViewChild(NgForm, { static: true }) form;
	@Input('deletedIssuses') deletedIssuses : any[] = [];
	@Input('deletedBasises') deletedBasises : any[] = [];
	@Input('removeBasises') removeBasises : any[] = [];
	@Input('deletedStatutes') deletedStatutes : any[] = [];
	@Input('autoCodes') autoCodes: string[] = [];
@Input('noTer') noTer: boolean
	@Input('data') data: any[];
	@Input('selectedrows') selectedrows: any[];
	@Input() amountHeading: string = 'Amount';
	@Input('header') title: string;
	@Input('id') id: string = '';
	@Input('cpDob') cpDob: Date;
	@Input('cpSex') cpSex: string;
	@Input('checkCp') checkCp: boolean;
	@Input() trainingOptions: any[] = [];
	@Input() enableSearch: boolean = true;
	@Input() height: any;
	@Input() showAmounts: boolean = false;
	@Input() isIIG: boolean;
	@Input() readonly: boolean = false;
	@Input() loading: boolean = false;
	@Output('selected') selected: EventEmitter<any[]> = new EventEmitter();
	@Output('unselected') unselected: EventEmitter<boolean> = new EventEmitter();
	@Output('init') init: EventEmitter<any> = new EventEmitter();
	@Output('onchange') onchange: EventEmitter<any> = new EventEmitter();
	allegationsComb: any[];
	dataSource: MatTableDataSource<any> = new MatTableDataSource();
	selection = new SelectionModel<number>(true, []);
	displayColumn: string[] = ['shortName'];
	observer$ = new BehaviorSubject(true);
	initialData: any[] = [];
	initialSelection: any[] = [];
	public updatedData: any[] = [];
	isPrivate: boolean;
	ariaResultAlert: number = 0;
	@Input('selectedBasis') selectedBasis :any;
	@Input('selectedIssue') selectedIssue : any;
	@Input('selectedStatute') selectedStatute : any;
	@Input('isFromEdit') isFromEdit : boolean = false;
	@Input('isAllegationEdit') isAllegationEdit : boolean = false;
	@Input('isClosedAllegationEdit') isClosedAllegationEdit : boolean = false;
	constructor(private alert: AlertService, private _cdrRef: ChangeDetectorRef, public cmnServ: CommonService) {}

	/**
	 * @description Emit an event if selection change is detected. partent will generate
	 * content for the next table.
	 */
	ngOnInit() {
		this.isPrivate = !!(this.cmnServ.userToken?.domains || []).find((item) => item === 'PRIVATE' || item === 'GLOBAL');
		this.selection.changed.pipe(takeWhile(() => this.observer$.value)).subscribe((res) => {
			this.emit();
		});
		
		if(this.isFromEdit || this.isAllegationEdit) this.initializeSelection();
	}

	initializeSelection(){
		if(this.selectedStatute) {
			this.selection.select(this.selectedStatute?.shortName || this.selectedStatute?.code);
		}
		if(this.selectedBasis) {
			if(!this.isAllegationEdit){
				const basis = this.data?.filter(e=> e.code === this.selectedBasis?.code)
				this.selection.select(basis[0]?.shortName || basis[0]?.code);
			}else {
				this.selection.select(this.selectedBasis?.shortName || this.selectedBasis?.code);
			}
		}
		if(this.selectedIssue){ 
			this.selection.select(this.selectedIssue?.shortName || this.selectedIssue?.code);
		}
		this.emit();
	}

	emit() {
		let selected = this.dataSource.data.filter((x, index) => {
			if (this.selection.selected.indexOf(x.shortName) >= 0 ||this.selection.selected.indexOf(x.id) >= 0 || this.selection.selected.indexOf(x.hearingSharedCodeId) >= 0) {
				x['benefitTypeAdditionalText'] = this.dataSource.data[index + 1]?.benefitTypeAdditionalText;
				let codes = this.dataSource.data[index + 1]?.trainingTypes || [];
				x['trainingTypes'] = this.trainingOptions.filter((x) => codes.includes(x.code || x));
				return x;
			}
		});
		this.selected.emit(selected);
	}

	updateTerColumns(rows) {
		this.isPrivate = !!(this.cmnServ.userToken?.domains || []).find((item) => item === 'PRIVATE' || item === 'GLOBAL');
		rows.forEach((row) => {
			if (row?.x?.code) {
				if (['NMNB_16', 'NMNB_9'].includes(row?.x?.code) && this.isPrivate) {
					row.x.isTerDisabled = false;
				} else {
					row.x.isTerDisabled = true;
				}
			}
		});
	}

	avoidSpecialChar(event: any) {
		const pastedData = event.clipboardData.getData('text/plain');
		if (/^[0-9.,]+$/.test(pastedData)) {
			return true;
		} else {
			event.preventDefault();
            return false;
		}

	}

	change() {
		setTimeout(() => {
			this.onchange.emit(this.form?.valid && !this.selection.isEmpty());
		}, 250);
	}

	checkAndFocus(row, event) {
		if (row && event && event.path) {
			setTimeout(() => {
				let tr: HTMLElement = event.path.find((ele) => ele.nodeName == 'TR');
				if (tr && tr.nextSibling && tr.nextSibling.nextSibling) {
					let expandRow = tr.nextSibling.nextSibling as HTMLElement;
					if (expandRow && expandRow.querySelector('textarea')) {
						expandRow.querySelector('textarea').focus();
					}
				}
			}, 500);
		}
	}

	sortData(data) {
		if (data[0].shortName) {
			data.sort(Utils.sortbyShortName);
			let gita = data.filter((x) => x.code === 'X');
			data = data.filter((x) => x.code !== 'X');
			if (this.isPrivate) {
				data.push(...gita);
			}
			let other = data.filter((x) => x.code === 'O');
			data = data.filter((x) => x.code !== 'O');
			data.push(...other);
		} else {
			data.sort(Utils.sortSharedCodes);
			let otherbasisnotlisted = data.filter((x) => x.code === 'OO');
			data = data.filter((x) => x.code !== 'OO');
			data.push(...otherbasisnotlisted);
			let otherbasisnotabove = data.filter((x) => x.code === 'O1');
			data = data.filter((x) => x.code !== 'O1');
			data.push(...otherbasisnotabove);
		}
		return data;
	}

	/**
	 * @description Update mat table on input data change
	 * @note suppose previous dataset A, current dataset B,
	 * we need to deselect everything that satisfies {x | x∈A && x∉B}
	 */
	ngOnChanges(changes): void {
		if (changes.data) {
			const rows = [];
			this.data = this.data && this.data.length > 0 ? this.sortData(this.data) : [];
			this.data.forEach((x) => {
				if (x) {
					if (x.shortName) {
						x.shortName = x.shortName || new Date().getTime() + (Math.random() * 1000).toString().replace('.', '');
						let selectedRow = (this.selectedrows || []).find((item) => item.shortName === x.shortName) || {};
						rows.push(x, {
							detailRow: true,
							x,
							benefitTypeAdditionalText:  (this.isAllegationEdit &&
								this.selectedBasis &&
								this.selectedBasis.shortName === x.shortName &&
								this.selectedBasis.benefitTypeAdditionalText)?
								this.selectedBasis.benefitTypeAdditionalText:(this.isAllegationEdit &&
								this.selectedIssue &&
								this.selectedIssue.shortName === x.shortName &&
								this.selectedIssue.benefitTypeAdditionalText)?
								this.selectedIssue.benefitTypeAdditionalText:
								x.benefitTypeAdditionalText,
							trainingTypes: (selectedRow.trainingTypes || x.trainingTypes || []).map((x) => x.code || x),
							isTargetedEquitableRelief: x.isTargetedEquitableRelief,
						});
					} else if (x.id) {
						x.id = x.id || new Date().getTime() + (Math.random() * 1000).toString().replace('.', '');
						let selectedRow = (this.selectedrows || []).find((item) => item.id === x.id) || {};
						rows.push(x, {
							detailRow: true,
							x,
							benefitTypeAdditionalText: x.benefitTypeAdditionalText,
							trainingTypes: (selectedRow.trainingTypes || x.trainingTypes || []).map((x) => x.code || x),
							isTargetedEquitableRelief: x.isTargetedEquitableRelief,
						});
} else if(x.hearingSharedCodeId) {
						let selectedRow = (this.selectedrows || []).find((item) => (item.benefitType?.hearingSharedCodeId === x.hearingSharedCodeId) || (item.hearingSharedCodeId === x.hearingSharedCodeId)) || {};
						x.hearingSharedCodeId = x.hearingSharedCodeId || new Date().getTime() + (Math.random() * 1000).toString().replace('.', '');
						x.amount = selectedRow.dollarAmount || selectedRow.amount;
						rows.push(x, {
							detailRow: true,
							x,
							amount:selectedRow.dollarAmount || selectedRow.amount,
							benefitTypeAdditionalText: selectedRow.benefitTypeAdditionalText || x.benefitTypeAdditionalText,
							trainingTypes: (selectedRow.trainingTypes || x.trainingTypes || []).map((x) => x.code || x),
							isTargetedEquitableRelief: x.isTargetedEquitableRelief,
						});

					}
				}
			});
			this.updatedData = rows;
			this.updateMatTable();
			this.updateTerColumns(rows);
		}
		if (changes.showAmounts) {
			if (this.showAmounts && this.noTer ) {
				this.displayColumn = ['shortName', 'amount'];
			}  else if(this.showAmounts && !this.noTer) {
                this.displayColumn = ['shortName','ter',  'amount'];
			} else {
				this.displayColumn = ['shortName'];
			}
		}
		if (changes.deletedIssuses) {
			if (changes?.deletedIssuses.currentValue?.length > 0) {
				this.onRowSelect(changes?.deletedIssuses.currentValue[0]);
			}
		}
		if (changes.removeBasises) {
			if (changes?.removeBasises.currentValue.length > 0) {
				this.unSelectBasis(changes?.removeBasises.currentValue)
			}
		}

		if (changes?.deletedBasises) {
			if (changes?.deletedBasises.currentValue?.length > 0) {
				this.onRowSelect(changes?.deletedBasises.currentValue[0]);
			}
		}
		if (changes?.deletedStatutes) {
			if (changes?.deletedStatutes.currentValue?.length > 0) {
				for (let i = 0; i < changes?.deletedStatutes?.currentValue?.length ; i++) {
				this.onRowSelect(changes?.deletedStatutes.currentValue[i]);
				}
			}
		}

		if (changes.data && this.updatedData) {
			this.updatedData.forEach((r) => {
				if (r.shortName) {
					r.shortName = r.shortName || parseInt((new Date().getTime() + Math.random() * 1000).toString());
				} else if (r.id) {
					r.id = r.id || parseInt((new Date().getTime() + Math.random() * 1000).toString());
} else if(r.hearingSharedCodeId) {
					r.hearingSharedCodeId = r.hearingSharedCodeId || parseInt((new Date().getTime() + Math.random() * 1000).toString());
				}
			});
			this.initialData = JSON.parse(JSON.stringify(this.updatedData));
		}
		// find all removed selected items, deselect them.
		if (changes?.data && changes.data?.previousValue && changes?.data?.previousValue.length > 0) {
			const selectedItemRemoved = this.selection.selected.filter(
				(items) => !changes.data.currentValue.some((c) => (c?.shortName === items) || c?.id === items)
			);
			selectedItemRemoved.forEach((item) => this.selection.deselect(item));
		}
		const selectedRowsChanges = changes.selectedrows;
		if (selectedRowsChanges && selectedRowsChanges.firstChange) {
			this.init.emit(false);
			this.initialSelection = JSON.parse(JSON.stringify(this.selectedrows));
			let ids;
			if (this.initialSelection.some(x => x.shortName)) {
				ids = this.initialSelection.map(({ shortName }) => shortName) || []; // get ids of selected rows
			} else if (this.initialSelection.some(x => x.code)) {
				ids = this.initialSelection.map(({ code }) => code) || []; // get ids of selected rows
} else if(this.initialSelection.some(x=>x.benefitType.hearingSharedCodeId)) {
				ids = this.initialSelection.map(x=>x.benefitType.hearingSharedCodeId) || []; // get ids of selected rows
			}
			this.dataSource.data.forEach((row) => { // loop over all rows
				if (ids?.includes(row.shortName) || ids?.includes(row.code) ||  ids?.includes(row.hearingSharedCodeId)) { // if id is in selected rows
					this.selection.select(row.shortName || row.id || row.hearingSharedCodeId); // select row
					this.emit(); // emit changes event
				}
			});
			this.init.emit(true);
		}
		if((changes?.selectedIssue || changes?.selectedBasis || changes?.selectedIssue) && this.isFromEdit){
			this.initializeSelection();
		}
	}

	ngAfterContentChecked(): void {
		//Called after every check of the component's or directive's content.
		//Add 'implements AfterContentChecked' to the class.
		this._cdrRef.detectChanges();
	}

	ngAfterViewInit() {
		this.dataSource.filterPredicate = (data, filters) => {
			const rs = this.displayColumn.map((item) => {
				if (Utils.isNullCondition(this.dataSource.filter)) {
					return true;
				}
				let rowValue = data[item] || (data.x || {})[item] || '';
				return rowValue.toLowerCase().includes(this.dataSource.filter.toLowerCase());
			});
			return rs.every(Boolean);
		};
	}
	/**
	 * @description update the input mat table with the input data
	 */
	updateMatTable() {
		if (Utils.notNullCondition(this.data)) {
			//this.data.forEach((x) => { if (x) { (x.id = x.id || new Date().getTime() + parseInt((Math.random() * 1000).toString())); } });
			this.dataSource.data = this.updatedData;
			this.dataSource._updateChangeSubscription();
		}
	}

	/**
	 * @description mat table overall filter.
	 * @param filterValue
	 */
	applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();

		// Since there are double the amount of items in the array, the correct amount has to be filtered out to get an accurate number
		this.ariaResultAlert = this.dataSource.filteredData.filter((data) => data.shortName || data.description).length;
	}

	/**
	 * @description Whether the number of selected elements matches the total number of rows.
	 */
	isAllSelected() {
		return this.selection.selected.length === this.dataSource.data.length;
	}

	/**
	 * @description select all rows on select. Unselect all rows on unselect. Disabled rows are ignored.
	 * @param event
	 */
	masterToggle(event) {
		event.checked
			? this.dataSource.filteredData
					.filter((row) => !row.isDisabled && !row.detailRow)
					.forEach((row) => {
						{
							this.selection.select(row.shortName ||row.id || row.hearingSharedCodeId);
						}
					})
			: this.clearSelection();
	}

	/**
	 * @description Clear the selection array
	 */
	public clearSelection() {
		this.selection.clear();
	}

	/**
	 * @description Return true if AllegationCategory row is invalid, otherwise false.
	 * @param row AllegationCategory
	 */
	isDisabled(row: any): boolean {
		if (!this.isIIG && this.title === 'Statutes' && this.checkCp) {
			/*as per scott's comments on 09/27/2019 we don't care about CP's age in angular*/
			/*if (row.id==='A' && (Utils.isNullCondition(this.cpDob) || this.isCpAgeYoungThanForty())) { return true; }*/
			// if (row ==='A' && Utils.isNullCondition(this.cpDob)) { return true; }
			// if (row.id==='E' && (Utils.isNullCondition(this.cpSex) || this.cpSex === '' || this.cpSex === 'N')) { return true; }
			if (row.code === 'A' && Utils.isNullCondition(this.cpDob)) {
				return true;
			}
			if (row.code === 'E' && (Utils.isNullCondition(this.cpSex) || this.cpSex === '' || this.cpSex === 'N')) {
				return true;
			}
		}
		// if (this.title === 'Basis' && Utils.notNullCondition(this.cpSex)) {
		//   if ((this.cpSex === 'F') && (row.id === 'GM' || row.id === 'PM')) { return true; }
		//   if ((this.cpSex === 'M') && (row.id === 'GF' || row.id === 'PF')) { return true; }
		// }-----
		return false;
	}

	/**
	 * @description Display error message when AllegationCategory row is invalid.
	 * @param row AllegationCategory
	 */
  showError(row) {
    const warningMessages = {
      A: 'ADEA cannot be added: Charging party DOB is missing or charging party is younger than 40.',
      E: 'EPA cannot be added: Charging party Sex is missing.',
      GM: 'The Basis cannot be added for female.',
      PM: 'The Basis cannot be added for female.',
      GF: 'The Basis cannot be added for male.',
      PF: 'The Basis cannot be added for male.'
    };

    if (!this.isIIG && warningMessages[row.id]) {
      return warningMessages[row.id];
    }

    return null;
  }

	public isAdditionalBox = ((row) => {
		if (row.hearingSharedCodeId) {
			return ['MNB_8', 'NMNB_17', 'MNB_10', 'LVEB_4'].includes(row.code);
		} else {
			return ['NMNB_9', 'NMNB_6', 'MNB_7', 'MNB_8', 'MNB_10', 'NMNB_16', 'O', 'OO', 'O1'].includes(row.code);
}
	});

	public isAdditionalSelect = (row) => ['NMNB_16'].includes(row.code || row.x?.code);
	// row?.description?.includes('Other Monetary') ||
	// row?.description?.includes('Job Referral') ||
	// row?.description?.includes('Training');

	public isExpansionDetailRow = (i: number, row: any) => row.hasOwnProperty('detailRow');
	public isSelected = (row) => {
	return this.isAdditionalBox(row.x) && this.selection.selected.includes(row?.x?.shortName || row?.x?.id  || row.x?.hearingSharedCodeId);
	}

	public showAdditionalTextBox = (row) => {
		if(row.shortName) {
		if (this.isAdditionalBox(row)) return this.selection.selected.includes(row?.shortName);
		} else {
			if (this.isAdditionalBox(row)) return this.selection.selected.includes(row?.id || row?.hearingSharedCodeId);	
		}
	};

	public getBenefitTypeAdditionalTextLabel = (row): string => {
		if (['MNB_7', 'MNB_8', 'NMNB_9', 'MNB_10', 'NMNB_17','LVEB_4', 'O', 'OO', 'O1'].includes(row?.x?.code)) return 'Enter Description...';
		if (['NMNB_6'].includes(row?.x?.code)) return 'Enter Referral Type...';
		if (['NMNB_16'].includes(row?.x?.code)) return 'Enter Target Audience...';
	};

	/**
	 * @description sets the observer behaviour subject to false to stop the subscriptions
	 */
	ngOnDestroy(): void {
		this.observer$.next(false);
	}

	reset() {
		this.selection.clear();
		this.ngOnChanges({ data: { previousValue: this.updatedData, currentValue: this.initialData } });
		this.ngOnChanges({ selectedrows: this.initialSelection });
	}

	selectRow(row, event) {
		if (event) {
			if (row.shortName) {
				this.selection.select(row.shortName);
				this.change();
			} else {
				this.selection.select(row.id || row.hearingSharedCodeId);
				this.change();
			}
		}
	}

	unSelectBasis(basisArray){
		if(basisArray){
			basisArray.forEach((e)=>{
				this.selection.toggle(e.shortName);
				if (!this.selection.selected.includes(e.shortName)) {
					this.unselected.emit(true);
				} else {
					this.unselected.emit(false);
				}
			})
			this.change();
		}
	}

	onRowSelect(row) {
		if (row.shortName) {
			this.selection.toggle(row.shortName);
			if (!this.selection.selected.includes(row.shortName)) {
				this.unselected.emit(true);
			} else {
				this.unselected.emit(false);
			}
			if (this.autoCodes.includes(row.code) && this.showAmounts) {
				if (this.selection.selected.includes(row.shortName)) {
					row.isTargetedEquitableRelief = true;
				} else {
					row.isTargetedEquitableRelief = false;
				}
			} else {
				row.isTargetedEquitableRelief = false;
			}
			this.change();
		} else  {
			this.selection.toggle(row.id || row.hearingSharedCodeId);
			if (!this.selection.selected.includes(row.id || row.hearingSharedCodeId)) {
				this.unselected.emit(true);
			} else {
				this.unselected.emit(false);
			}
			if (this.autoCodes.includes(row.code) && this.showAmounts) {
				if (this.selection.selected.includes(row.id || row.hearingSharedCodeId)) {
					row.isTargetedEquitableRelief = true;
				} else {
					row.isTargetedEquitableRelief = false;
				}
			} else {
				row.isTargetedEquitableRelief = false;
			}
			this.change();
		}

	}
}
